import React from 'react';
export const ProductShowcaseSection = () => {
  const items = [{
    title: 'Módulo 1',
    name: 'Mente Despierta',
    icon: '🧠',
    color: 'bg-blue-500/20 border-blue-500/50'
  }, {
    title: 'Módulo 2',
    name: 'Movilidad Sin Miedo',
    icon: '🦵',
    color: 'bg-green-500/20 border-green-500/50'
  }, {
    title: 'Módulo 3',
    name: 'Cuidado Experto',
    icon: '🏥',
    color: 'bg-red-500/20 border-red-500/50'
  }, {
    title: 'Módulo 4',
    name: 'Bitácora de Control 360',
    icon: '📋',
    color: 'bg-purple-500/20 border-purple-500/50'
  }, {
    title: 'Módulo 5',
    name: 'Guía del Cuidador',
    icon: '⭐',
    color: 'bg-yellow-500/20 border-yellow-500/50'
  }, {
    title: 'Módulo Maestro',
    name: '150+ Ejercicios por Niveles',
    icon: '⚡',
    color: 'bg-familia-cyan/20 border-familia-cyan/50'
  }, {
    title: 'Bono 1',
    name: 'Cocina Vital',
    icon: '🍎',
    color: 'bg-orange-500/20 border-orange-500/50'
  }, {
    title: 'Bono 2',
    name: 'Kit de Socialización',
    icon: '👥',
    color: 'bg-teal-500/20 border-teal-500/50'
  }, {
    title: 'Bono 3',
    name: 'Checklist Hogar Seguro',
    icon: '🏠',
    color: 'bg-indigo-500/20 border-indigo-500/50'
  }];
  return <section id="visualizacion" className="bg-familia-bg py-16 px-4 md:px-6" data-id="element-204">
      <div className="max-w-7xl mx-auto text-center" data-id="element-205">
        <h2 className="text-3xl md:text-5xl font-display font-bold mb-12" data-id="element-206">
          ¿Qué incluye el <span className="text-familia-cyan" data-id="element-207">Master Kit</span>?
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6" data-id="element-208">
          {items.map((item, i) => <div key={i} className={`p-6 rounded-2xl border-2 ${item.color} flex flex-col items-center justify-center transition-transform hover:scale-105 cursor-default`} data-id="element-209">
              <span className="text-4xl md:text-5xl mb-4" data-id="element-210">{item.icon}</span>
              <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-white/60 mb-1" data-id="element-211">
                {item.title}
              </span>
              <span className="text-sm md:text-base font-bold leading-tight" data-id="element-212">
                {item.name}
              </span>
            </div>)}
        </div>

        <div className="mt-16 relative max-w-4xl mx-auto" data-id="element-213">
          <div className="absolute inset-0 bg-familia-cyan/20 blur-[100px] rounded-full" data-id="element-214" />
          <img src="https://cdn.magicpatterns.com/uploads/wD6XHHXqEzi2b4vbyPnFv3/hf_20260528_015615_d7bdc0e4-f184-4423-868f-2fe77bd4c3a9-removebg-preview.png" alt="Vitalidad 360 Master Kit Visualización" className="relative z-10 w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-215" />
        </div>
      </div>
    </section>;
};